export const BACKGROUND_IMAGE_CARD_TYPE = 0;

export const FEATURED_CARD_TYPE = 1;

export const COMMON_CARD_TYPE = 2;